import { DoseMatrix } from '~/domain/patient/doseMatrix';

/**
 * Whether `dose` can be drawn on the image with series `seriesUid`: its
 * structure set lies on that image. A dose with no structure set names no
 * image, so it is offered with every image; loading it is refused with the
 * reason.
 */
export function isDoseOfImage(dose: DoseMatrix, seriesUid: string): boolean {
    const structureSet = dose.structureSet;
    return !structureSet || structureSet.image?.seriesUid === seriesUid;
}
